<template>
  <RouterLink
    v-slot="{ isExactActive, href, navigate }"
    custom
    :to="!isNotAuthorised ? { name: 'NewChat' } : { name: 'NotAuthorised' }"
  >
    <a :href="href" class="MenuItemNewChat" @click="navigate">
      <TheSidebarMenuItem :isActive="isExactActive">
        <template #icon>
          <UITooltip placement="bottom">
            <template #trigger>
              <UIIcon name="newChat" />
            </template>
            <template #content>
              <div>New chat</div>
              <div class="TheSidebarHeader__icon-shortcut">
                {{ isMac ? 'CMD+SHIFT+O' : 'CTRL+SHIFT+O' }}
              </div>
            </template>
          </UITooltip>
        </template>
        <template #label>New chat</template>
      </TheSidebarMenuItem>
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import { UITooltip } from '@foundever/ui-lib'
import { storeToRefs } from 'pinia'

import { useAppStore } from '@/store/app'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

import TheSidebarMenuItem from '../TheSidebarMenuItem.vue'

const { isNotAuthorisedPage: isNotAuthorised, isMac } =
  storeToRefs(useAppStore())
</script>

<style scoped lang="scss">
.MenuItemNewChat {
  display: block;
  text-decoration: none;
}
</style>
